import { ConceptValueDataType } from '@fusion-advantage/backcompat'
import { FormRootState } from '../../redux/formStore'
import { selectForm } from '../../redux/selectForm'
import {
	CalcRuntimeError,
	CalcType,
	directoryValidity,
	ExecutableCalc,
	ExecutableCalcCalculateFunction,
	ExecutableCalcCalculateOk,
	ExecutableCalcPrecedence,
} from '@fusion-advantage/formlib'
import { Result } from 'neverthrow'

// One Default-precedence validation calc per concept with Directory-driven checks
// (required, date, range, numeric). A Primary validation calc for the same cid
// replaces it; per-concept exceptions belong in those script calcs, which can
// keep the Directory checks they still want via DIR_VALIDITY.
export const createDefaultValidationCalcs = (getState: () => FormRootState): ExecutableCalc[] => {
	const calcs: ExecutableCalc[] = []
	const concepts = selectForm(getState()).concepts
	for(const cid in concepts) {
		const concept = concepts[cid]
		const isDate = concept.valueDataType === ConceptValueDataType.Date
		const isRequired = concept.isRequired
		const hasRange = Boolean(concept.valueRange)
		const isNumeric = isNumericConcept(concept.valueDataType)

		if (!isDate && !isRequired && !hasRange && !isNumeric) continue

		const calculate: ExecutableCalcCalculateFunction = (ctx): Result<ExecutableCalcCalculateOk, CalcRuntimeError> => {
			return directoryValidity(ctx, cid).map(returnValue => ({ calcType: CalcType.Validation, returnValue }))
		}
		calcs.push(new ExecutableCalc({
			calcType: CalcType.Validation,
			precedence: ExecutableCalcPrecedence.Default,
			outputCid: cid,
			inputCids: [cid],
			selectCalculate: () => calculate,
		}))
	}
	return calcs
}

const isNumericConcept = (valueDataType: ConceptValueDataType | null) => {
	return valueDataType === ConceptValueDataType.Decimal ||
		valueDataType === ConceptValueDataType.Integer
}
